'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;
// import exu from 'assets/img/account/exu@2x.png';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Constant = require('helpers/Constant');

var _Constant2 = _interopRequireDefault(_Constant);

var _support = require('helpers/support');

var _reactRedux = require('react-redux');

var _address = require('redux/modules/address');

var addressAction = _interopRequireWildcard(_address);

var _voucher = require('redux/modules/voucher');

var vouchersAction = _interopRequireWildcard(_voucher);

var _auth = require('redux/modules/auth');

var authActions = _interopRequireWildcard(_auth);

var _AllReward = require('./AllReward');

var _AllReward2 = _interopRequireDefault(_AllReward);

var _MyReward = require('./MyReward');

var _MyReward2 = _interopRequireDefault(_MyReward);

var _BottomInfoUser = require('./BottomInfoUser');

var _BottomInfoUser2 = _interopRequireDefault(_BottomInfoUser);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LookmeReward = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    tabs: state.voucher.tabs,
    // SUBCAT_FILTER: state.voucher.SUBCAT_FILTER,
    MY_REWARD_LIST: state.voucher.MY_REWARD_LIST,
    REWARD_LIST_AT_HOME: state.voucher.REWARD_LIST_AT_HOME,
    REWARD_LIST_AT_SPA: state.voucher.REWARD_LIST_AT_SPA,
    ALL_REWARD_LIST: state.voucher.ALL_REWARD_LIST,
    configHeader: state.setup.configHeader,
    province: state.address.province,
    districtOptions: state.address.districtOptions
  };
}, (0, _extends3.default)({
  getMyReward: vouchersAction.getMyReward,
  getRewardAtSpa: vouchersAction.getRewardAtSpa,
  getRewardAtHome: vouchersAction.getRewardAtHome,
  getAllReward: vouchersAction.getAllReward,
  changeTab: vouchersAction.changeTab,
  loadDistrict: addressAction.loadDistrict
}, authActions)), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(LookmeReward, _Component);

  function LookmeReward() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, LookmeReward);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = LookmeReward.__proto__ || (0, _getPrototypeOf2.default)(LookmeReward)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      district: null

    }, _this.userNo = -1, _this.onChangeDistrict = function (district) {
      _this.setState({ district: district });
      _this.getResult({ district: district });
    }, _this.onChangeFilter = function (subcat) {
      console.log(subcat);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(LookmeReward, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          user = _props.user,
          districtOptions = _props.districtOptions,
          dataSpa = _props.REWARD_LIST_AT_SPA.data,
          dataHome = _props.REWARD_LIST_AT_HOME.data,
          province = _props.province;

      var filter = {
        pageSize: 1000
      };
      this.userNo = _support.Helper.rankNo(user ? user.rank : null);
      this.props.getAllReward(filter);
      this.props.getMyReward();
      if (!dataSpa || !dataSpa.length) this.props.getRewardAtSpa();
      if (!dataHome || !dataHome.length) this.props.getRewardAtHome();
      if ((!districtOptions || !districtOptions.length) && this.props.province) {
        this.props.loadDistrict(this.props.province);
      }
    }
  }, {
    key: 'getResult',
    value: function getResult(_ref2) {
      var district = _ref2.district;

      // let dis = this.state.district;
      // if (district) {
      //   dis = district;
      // }
      console.log({ district: district });
      var query = {
        district: district ? district.value : ''
        // sort: sort || "",
        // sortTo: sortTo || "",
      };
      // if (sort == "nearby") {
      //   query = {
      //     ...query,
      //     sort: "",
      //     nearby: true,
      //   };
      // }
      this.props.getAllReward(query);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./LookmeReward.scss');
      var district = this.state.district;
      var _props2 = this.props,
          user = _props2.user,
          configHeader = _props2.configHeader,
          dataSpa = _props2.REWARD_LIST_AT_SPA.data,
          dataHome = _props2.REWARD_LIST_AT_HOME.data;
      var _props3 = this.props,
          MY_REWARD_LIST = _props3.MY_REWARD_LIST,
          tabs = _props3.tabs;

      var botInfo = null;
      var dynamicData = [];
      if (configHeader.atHome) dynamicData = dataHome;
      if (configHeader.atSpa) dynamicData = dataSpa;
      if (user && user.rank) {
        botInfo = _Constant2.default.RANK[user.rank];
        botInfo.pointReward = user.rewardPoints;
      }
      return _react2.default.createElement(
        'div',
        { className: styles.container },
        _react2.default.createElement(
          'div',
          { className: styles.navigateBar },
          _react2.default.createElement(
            'div',
            {
              className: styles.screen + ' ' + (tabs === 'allReward' ? styles.selected : ''),
              onClick: function onClick() {
                return _this2.props.changeTab('allReward');
              }
            },
            _react2.default.createElement(
              'div',
              { className: styles.text },
              'T\u1EA5t c\u1EA3'
            )
          ),
          _react2.default.createElement(
            'div',
            {
              className: styles.screen + ' ' + (tabs === 'myReward' ? styles.selected : ''),
              onClick: function onClick() {
                return _this2.props.changeTab('myReward');
              }
            },
            _react2.default.createElement(
              'div',
              { className: styles.text },
              'C\u1EE7a t\xF4i',
              ' ',
              user && MY_REWARD_LIST.number ? ' (' + MY_REWARD_LIST.number + ')' : ''
            )
          )
        ),
        tabs === 'allReward' && _react2.default.createElement(_AllReward2.default, {
          history: this.props.history,
          userNo: this.userNo,
          changeTab: this.props.changeTab,
          dynamicData: dynamicData,
          district: district,
          onChangeDistrict: this.onChangeDistrict,
          onChangeFilter: this.onChangeFilter,
          homeOff: configHeader.homeOff
        }),
        tabs === 'myReward' && _react2.default.createElement(_MyReward2.default, { history: this.props.history, userNo: this.userNo }),
        botInfo && false && _react2.default.createElement(_BottomInfoUser2.default, { data: botInfo })
      );
    }
  }]);
  return LookmeReward;
}(_react.Component), _class2.propTypes = {
  // @data
  province: _react.PropTypes.string,
  tabs: _react.PropTypes.string,
  user: _react.PropTypes.object,
  location: _react.PropTypes.object,
  history: _react.PropTypes.object,
  // SUBCAT_FILTER: PropTypes.object,
  MY_REWARD_LIST: _react.PropTypes.object,
  ALL_REWARD_LIST: _react.PropTypes.object,
  REWARD_LIST_AT_HOME: _react.PropTypes.object,
  REWARD_LIST_AT_SPA: _react.PropTypes.object,
  configHeader: _react.PropTypes.object,
  districtOptions: _react.PropTypes.array,
  // @action
  getMyReward: _react.PropTypes.func,
  getAllReward: _react.PropTypes.func,
  getRewardAtHome: _react.PropTypes.func,
  getRewardAtSpa: _react.PropTypes.func,
  loadDistrict: _react.PropTypes.func,
  changeTab: _react.PropTypes.func

}, _temp2)) || _class);
exports.default = LookmeReward;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Reward/LookmeReward.js
// module id = 1627
// module chunks = 0